import React, { useEffect } from 'react';
import { axiosInstnace } from "../../../util/util";
import { endPoints } from "../../../config";

const Map = (props) => {
  useEffect(() => {
    
    let statesGroupedData = groupBy(props.dsadata, 'state');
    let citiesGroupedData = groupBy(props.dsadata, 'city');
    
    let mapData = [];
    let citiesData = [];

    (async () => {
      const cityDataResponse = await axiosInstnace.get(`${endPoints.getCityLatLong}`);

      let citiesLocationJSON = cityDataResponse.data.data.data;

      for (const stateName in statesGroupedData) {
        if (Object.hasOwnProperty.call(statesGroupedData, stateName)) {
          if(stateCodes[stateName]){
            mapData.push([stateCodes[stateName], statesGroupedData[stateName].length ]);
          }
        }
      }

      for (const cityName in citiesGroupedData) {
        if (Object.hasOwnProperty.call(citiesGroupedData, cityName)) {
          if(citiesLocationJSON[cityName.toLowerCase()]){
            citiesData.push({
              name: cityName + " - " + citiesGroupedData[cityName].length,
              lat: citiesLocationJSON[cityName.toLowerCase()].latitude,
              lon: citiesLocationJSON[cityName.toLowerCase()].longitude,
              label: cityName
            });
          }else{
            console.error(cityName, "Not found in JSON Db");
          }
        }
      }
  
      showMap(mapData, citiesData);
    })();
  }, [props.dsadata])

  
  const groupBy = (items, key) => items.reduce(
    (result, item) => ({
      ...result,
      [item[key]]: [
        ...(result[item[key]] || []),
        item,
      ],
    }), 
    {},
  );

  const stateCodes = {
    "Andaman and Nicobar Islands": "in-an",
    "Andhra Pradesh": "in-ap",
    "Arunachal Pradesh": "in-ar",
    "Assam": "in-as",
    "Bihar": "in-br",
    "Chandigarh": "in-ch",
    "Chhattisgarh": "in-ct",
    "Dadra and Nagar Haveli": "in-dn",
    "Daman and Diu": "in-3464",
    "Delhi": "in-dl",
    "Goa": "in-ga",
    "Gujarat": "in-2984",
    "Haryana": "in-hr",
    "Himachal Pradesh": "in-hp",
    "Jammu and Kashmir": "in-jk",
    "Jharkhand": "in-jh",
    "Karnataka": "in-ka",
    "Kerala": "in-kl",
    "Ladakh": "in-la",
    "Lakshadweep": "in-ld",
    "Madhya Pradesh": "in-mp",
    "Maharashtra": "in-mh",
    "Manipur": "in-mn",
    "Meghalaya": "in-ml",
    "Mizoram": "in-mz",
    "Nagaland": "in-nl",
    "Odisha": "in-or",
    "Puducherry": "in-py",
    "Punjab": "in-pb",
    "Rajasthan": "in-rj",
    "Sikkim": "in-sk",
    "Tamil Nadu": "in-tn",
    "Telangana": "in-tg",
    "Tripura": "in-tr",
    "Uttar Pradesh": "in-up",
    "Uttarakhand": "in-ut",
    "West Bengal": "in-wb",
  };

  //Show the map at home page.
  const showMap = (data, cityData) => {
    return (
      <div> {
        Highcharts.mapChart('map_india', {
            
            chart: {
                map: 'countries/in/in-all',
                height: 900,
                
                events: {
                  selection: function () {
                    for (const i in this.series) {
                      if (Object.hasOwnProperty.call(this.series, i) && i > 0) {
                        this.series[i].setVisible(false);
                      }
                    }
                  }
                }
            },
        
            title: {
              text: 'Trade partner by State'
            },
        
            mapNavigation: {
              enabled: true,
              buttonOptions: {
                  verticalAlign: 'bottom'
              }
            },
        
            colorAxis: {
                min: 100000
            },
        
            series: [
              {
                  data: data,
                  name: ' ',
                  states: {
                      hover: {
                          color: '#CCC'
                      }
                  },
                  dataLabels: {
                      enabled: true,
                      formatter: function() {
                        return this.point.value ? this.point.name + " - " + this.point.value : this.point.name + " - " + '0';
                      }
                  },
                  events: {
                    click: function (e) {
                      e.point.zoomTo();

                      this.chart.showResetZoom();

                      for (const i in this.chart.series) {
                        if (Object.hasOwnProperty.call(this.chart.series, i) && i > 0) {
                          this.chart.series[i].setVisible(true);
                        }
                      }
                    }
                  }
              },
              {
                type: 'mappoint',
                name: 'Cities',
                color: '#4f4575',

                visible: false,
                maxSize: '12%',
                data: cityData,
                dataLabels: {
                  enabled: true
                },
              }
            ],
            exporting: { enabled: false },
            allowPointSelect: true,
            cursor: 'pointer'
          }
        )}
      </div>
    )
  }


  return (
    <div id="map_india"></div>
  )
}

export default Map;


// WEBPACK FOOTER //
// ./web/components/admin/dsa_management/Map.jsx